import React, { useState } from "react";
import { Modal, Space, Select, Input, DatePicker } from "antd";
import styles from "./FilterModal.module.scss";
import moment from "moment";
import { useTranslation } from "react-i18next";

const FilterModal = ({ open, columns, filters, onClose, onApply }) => {
  const { t: translation } = useTranslation();
  const [localFilters, setLocalFilters] = useState(filters);

  React.useEffect(() => {
    setLocalFilters(filters);
  }, [filters, open]);

  return (
    <Modal
      title={translation("dataTable.filter")}
      open={open}
      onCancel={onClose}
      onOk={() => onApply(localFilters)}
      okText={translation("dataTable.apply")}
      cancelText={translation("dataTable.cancel")}
      width={400}
      centered
      className={styles.filterModal}
    >
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        {columns
          .filter((col) => col.dataIndex && col.filterType)
          .map((col) => (
            <div key={col.dataIndex}>
              <div className={styles.filterLabel}>{col.title}</div>
              {col.filterType === "select" && (
                <Select
                  style={{ width: "100%" }}
                  allowClear
                  placeholder={translation("dataTable.select")}
                  value={localFilters[col.dataIndex]}
                  onChange={(value) =>
                    setLocalFilters((f) => ({ ...f, [col.dataIndex]: value }))
                  }
                  options={col.filterOptions}
                  size="large"
                />
              )}
              {col.filterType === "search" && (
                <Input
                  placeholder={translation("dataTable.search")}
                  value={localFilters[col.dataIndex]}
                  onChange={(e) =>
                    setLocalFilters((f) => ({
                      ...f,
                      [col.dataIndex]: e.target.value,
                    }))
                  }
                  size="large"
                />
              )}
              {col.filterType === "date" && (
                <DatePicker
                  style={{ width: "100%" }}
                  allowClear
                  placeholder={translation("dataTable.select")}
                  value={
                    localFilters[col.dataIndex]
                      ? moment(localFilters[col.dataIndex], "DD/MM/YYYY")
                      : null
                  }
                  onChange={(value) =>
                    setLocalFilters((f) => ({
                      ...f,
                      [col.dataIndex]: moment(value).format("DD/MM/YYYY"),
                    }))
                  }
                  size="large"
                />
              )}
            </div>
          ))}
      </Space>
    </Modal>
  );
};

export default FilterModal;
